import * as types from './actionTypes';  
import ratingListApi from '../api/ratingListApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doRatingList(ext_id) {

  return {
    type: types.DO_RATINGLIST, 
    ext_id
  };
}

export function doRatingListRes(data) {  
  return {
    type: types.DO_RATINGLIST_RES, 
    data
  };
}

export function getRatingList(ext_id) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      ratingListApi.doRatingList(ext_id).then(data => {
        dispatch(doRatingListRes(data));
        dispatch(doRatingListRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}